exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".buttonAndBadge{position:relative}.wordCount{position:absolute;bottom:5px;right:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--3-1!../node_modules/postcss-loader/lib!../node_modules/sass-loader/lib/loader.js!./assets/scss/ButtonAndBadge.scss
// module id = 524
// module chunks = 0